var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h2',[_vm._v("Link not supported in Web App")]),_vm._v(" This link needs to be opened in the mobile app: CortexLight ")])
}]

export { render, staticRenderFns }